import { render, staticRenderFns } from "./PlanCuentas.vue?vue&type=template&id=36edf39d&"
import script from "./PlanCuentas.vue?vue&type=script&lang=js&"
export * from "./PlanCuentas.vue?vue&type=script&lang=js&"
import style0 from "./PlanCuentas.vue?vue&type=style&index=0&id=36edf39d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports